import { useMutation } from '@tanstack/react-query';
import type { DeliveryJob } from '../model/job.types';
import { TEMPLATE_FILE_NAME, fetchJobSource, fetchMediaPlanTemplate, saveBlob } from './template';

/** Hands back the file a job was created from, under the name it was uploaded with. */
export function useDownloadJobSource() {
  return useMutation({
    mutationFn: async (job: DeliveryJob) => {
      const blob = await fetchJobSource(job.id);
      saveBlob(blob, job.source.fileName);
    },
  });
}

/** Downloads the blank media plan template. Not a query — it has no cached state. */
export function useDownloadMediaPlanTemplate() {
  return useMutation({
    mutationFn: async () => {
      const blob = await fetchMediaPlanTemplate();
      saveBlob(blob, TEMPLATE_FILE_NAME);
    },
  });
}
